export default "__VITE_ASSET__Czv$eWZo__"